import * as actionTypes from "../actions/actionTypes";
import { noop } from "lodash-es";
import { reportDeprecated } from "../../utils/errorHandling";

/**
 * @typedef {"success"|"info"|"danger"|"warning"} MessageType
 */

let savedDispatchFunction = noop;

export function setMessageDispatch(dispatchCallback) {
  savedDispatchFunction = dispatchCallback;
}

export const dismissToast = (id) => {
  return {
    type: actionTypes.REMOVE_TOAST,
    id,
  };
};

export function showToast(action, message, type) {
  const dispatch = savedDispatchFunction;
  if (typeof message === "function") {
    if (message === dispatch) {
      reportDeprecated(
        "'dispatch' does not need to be passed to this function."
      );
    }
    message = arguments[2];
    type = arguments[3];
  }
  if (typeof message === "string") {
    message = [message];
  }
  message.map((error, index) =>
    dispatch({
      type: action,
      meta: {
        toasts: [
          {
            id: action + index,
            title: type === "danger" ? "Error" : "Success",
            message: error,
            type,
            condition: action,
          },
        ],
      },
    })
  );
}

let autoIncrementingId = 0;

/**
 * @param message {string}
 * @param type {MessageType}
 * @param {Function=} dispatchFunctionOverride
 */
export function showToastWithTimeout(message, type, dispatchFunctionOverride) {
  let dispatch = savedDispatchFunction;
  if (typeof message === "function") {
    reportDeprecated("'dispatch' does not need to be passed to this function.");
    message = arguments[1];
    type = arguments[2];
  } else if (dispatchFunctionOverride) {
    dispatch = dispatchFunctionOverride;
  }
  if (Array.isArray(message)) {
    return message.map((message) =>
      showToastWithTimeout(message, type, dispatch)
    );
  }

  const titles = {
    danger: "Error",
    warning: "Warning",
    success: "Success",
    info: "Info",
  };

  const id = `toast-${++autoIncrementingId}`;
  dispatch({
    type: actionTypes.SHOW_ACTION_TOAST_MESSAGE,
    meta: {
      toasts: [
        {
          id,
          title: titles[type],
          message,
          type,
          condition: actionTypes.SHOW_ACTION_TOAST_MESSAGE,
        },
      ],
    },
  });
  setTimeout(() => {
    dismissToast(id);
  }, 5000);

  return id;
}

export const showActionToast = (message, link, settings) => (dispatch) => {
  dispatch({
    type: actionTypes.SHOW_ACTION_TOAST_MESSAGE,
    message,
    link,
    settings,
  });
};
export const hideActionToast = () => (dispatch) =>
  dispatch({ type: actionTypes.HIDE_ACTION_TOAST_MESSAGE });
